import "core-js/modules/es.array.push.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.for-each.js";
import "core-js/modules/esnext.iterator.map.js";
/**
 * 针对CommonTable、CommonSearchPage组件的公用导出
 * 导出数据到Excel文件
 * */
import { exportDataToExcel } from './index';
import { getSchemaByKeyArray } from '@/utils/common';
import _ from 'lodash';
export function exportData(tableObjs, fileName, width, header) {
  const config = [];
  const headerData = header || [];
  tableObjs.forEach(obj => {
    config.push(headerExportConfig(obj, width, headerData));
  });
  if (headerData && headerData.length > 0) {
    config[0].header = headerData;
  }
  exportDataToExcel(config, fileName + '.xlsx');
}
// 导出Config
const headerExportConfig = (obj, width, headerData) => {
  const tableSchema = getFiledSchema(obj.tableSchema);
  const tempSchema = getSchemaByKeyArray(obj.schema, tableSchema);
  const header = [];
  const columnsWidth = [];
  Object.keys(tempSchema.properties).forEach(key => {
    header.push(tempSchema.properties[key].title);
    let widthTemp = obj.tableUiSchema?.width ? obj.tableUiSchema?.width : width;
    if (headerData && headerData.length > 0) {
      widthTemp = obj.tableUiSchema[key]?.width ? obj.tableUiSchema[key]?.width : width;
      if (typeof widthTemp === 'number') {
        widthTemp = widthTemp.toString();
      }
    }
    if (!widthTemp) {
      columnsWidth.push(20);
    } else if (widthTemp.indexOf('px') > -1) {
      columnsWidth.push(parseInt(widthTemp.split('px')[0]) / 8);
    } else {
      columnsWidth.push(parseInt(widthTemp) / 8);
    }
  });
  let onExportData = _.cloneDeep(obj.tableData);
  if (!onExportData || onExportData.length < 1) {
    onExportData = [];
  }
  const config = {
    data: onExportData,
    fields: Object.keys(tempSchema.properties),
    header: [header],
    merges: obj.headMerge ? obj.headMerge : [],
    sheetName: obj.sheetName,
    domains: {},
    dataValidation: [],
    // protect: {},
    attrs: [],
    columnsWidth: columnsWidth
  };
  Object.keys(obj.schema.properties).forEach(key => {
    const prop = obj.schema.properties[key];
    if (prop.oneOf) {
      config.domains[key] = prop.oneOf.map(oneOf => {
        return {
          Code: oneOf.const,
          Text: oneOf.title
        };
      });
    }
  });
  // 设置单元格边框样式
  config.attrs.push({
    rowStart: 0,
    rowEnd: config.header.length + config.data.length - 1,
    attr: {
      alignment: {
        wrapText: true
        // vertical: 'middle', horizontal: 'center'
      },
      border: {
        top: {
          style: 'thin'
        },
        left: {
          style: 'thin'
        },
        bottom: {
          style: 'thin'
        },
        right: {
          style: 'thin'
        }
      }
    }
  });
  // 设置第一行填充颜色，字体加粗
  config.attrs.push({
    rowStart: 0,
    rowEnd: 0,
    colStart: 0,
    colEnd: config.fields.length - 1,
    attr: {
      fill: {
        type: 'pattern',
        pattern: 'solid',
        fgColor: {
          argb: '99CCFF'
        }
      },
      font: {
        bold: true
      }
    }
  });
  // 冻结表头
  config.attrs.push({
    attr: {
      views: [{
        state: 'frozen',
        ySplit: config.header.length,
        xSplit: 1
      }]
    }
  });
  console.log('config', config);
  return config;
};
/**
 * 多级表头平铺
 * @param tableSchemaVar
 */
const getFiledSchema = tableSchemaVar => {
  const tableSchema = [];
  tableSchemaVar.forEach(item => {
    // let i = index
    if (typeof item === 'object' && item.children) {
      tableSchema.push(item.prop);
      const tempSchema = getFiledSchema(item.children);
      tableSchema.push(...tempSchema);
    } else if (typeof item === 'string') {
      tableSchema.push(item);
    }
  });
  return tableSchema;
};
export default {
  exportData
};